var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doughnut-wrapper"},[_c('doughnut-chart',{attrs:{"chartData":_vm.chartData}}),_c('div',{staticClass:"inner-chart"},[_c('div',{staticClass:"inner-sum"},[_vm._v(" "+_vm._s(_vm.targetSum)+" ")]),_c('div',{staticClass:"inner-text mt-2"},[_vm._v(" "+_vm._s('Home Goal')+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }